"use client";

import * as React from "react";
import Image, { StaticImageData } from "next/image";
import { Card } from "@/components/ui/card";
import { useTranslations } from "use-intl";
interface NoSubscriptionCardProps {
  title?: string;
  description?: string;
  imageSrc: StaticImageData;
  email?: {
    to: string;
    subject: string;
    body: string;
  };
  children?: React.ReactNode;
}
const NoSubscriptionCard: React.FC<NoSubscriptionCardProps> = ({
  imageSrc,
  title,
  description,
  email,
  children
}) => {
  const formattedBody = email?.body ? encodeURIComponent(email.body) : "";
  const t = useTranslations();
  return <Card className="relative flex h-auto flex-wrap items-center justify-center rounded-3xl py-10 mobile:py-16 tablet:h-[70vh] tablet:overflow-hidden tablet:overflow-y-auto tablet:p-12" data-sentry-element="Card" data-sentry-component="NoSubscriptionCard" data-sentry-source-file="NoSubscriptionCard.tsx">
      <div className="absolute inset-0 top-1/2 flex h-full w-full -translate-y-1/2 items-center justify-center">
        <div className="relative h-[80%] w-full">
          <Image src={imageSrc} alt="Description for the image" layout="fill" objectFit="contain" className="pointer-events-none select-none opacity-10 blur-[1px]" data-sentry-element="Image" data-sentry-source-file="NoSubscriptionCard.tsx" />
        </div>
      </div>
      <div className="z-10 w-full max-w-2xl px-8 mobile:w-2/3 mobile:px-0 wide:w-1/2">
        <div className="mb-8 flex flex-col gap-2">
          {title && <h2 className="text-4xl font-bold leading-none tracking-tight">{title}</h2>}
          {description && <p className="text-lg text-primary">{description}</p>}
          {email && <a href={`mailto:${email.to}?subject=${email.subject}&body=${formattedBody}`} className="mt-2 w-fit rounded-3xl bg-blue-700 px-6 py-2 text-center text-lg text-white transition-all hover:bg-blue-800">
              {t("src_app_uat_institutionSlug_transparency_components_NoSubscriptionCard_tsx_0")}
            </a>}
          {children}
        </div>
      </div>
    </Card>;
};
export default NoSubscriptionCard;